module.exports = __webpack_public_path__ + "img/arrow-right.2dc11cc2.svg";